import { StatusChangeByComponentView } from "./StatusChangeByComponentView.model";

export class RequestStatusLegalView extends StatusChangeByComponentView{
    public LegalPersonChange: boolean;
    public message : string;
    public fileOtros : string;
    public fileOtrosName : string;
    public fileOficinas : string;
    public fileOficinasName : string;
}